var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56",
    width: 56,
    height: 56,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#C8C8C8",
    rx: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18 31c-.854 0-1.568-.294-2.14-.883-.573-.59-.86-1.306-.86-2.15 0-.845.281-1.55.844-2.117.562-.567 1.281-.85 2.156-.85.875 0 1.594.283 2.156.85.563.567.844 1.272.844 2.117 0 .844-.287 1.56-.86 2.15-.572.589-1.286.883-2.14.883zM28 31c-.854 0-1.568-.294-2.14-.883-.573-.59-.86-1.306-.86-2.15 0-.845.281-1.55.844-2.117.562-.567 1.281-.85 2.156-.85.875 0 1.594.283 2.156.85.563.567.844 1.272.844 2.117 0 .844-.287 1.56-.86 2.15-.572.589-1.286.883-2.14.883zM38 31c-.854 0-1.568-.294-2.14-.883-.574-.59-.86-1.306-.86-2.15 0-.845.281-1.55.844-2.117.562-.567 1.281-.85 2.156-.85.875 0 1.594.283 2.156.85.563.567.844 1.272.844 2.117 0 .844-.286 1.56-.86 2.15-.572.589-1.286.883-2.14.883z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.ff52a2b4c2842acbecbc076ce88a644a.svg";
export { ForwardRef as ReactComponent };